import { useState } from "react";
import Accordion from "./Accordion";
import Starter from "./Starter";
import CustomerSurvey from "./CustomerSurvey";
import { faqs } from "../../../components/Data/data";



const Faq = () => {
 
  const [toggle, setToggle] = useState(0);
  const [open, setOpen] = useState(false);

  function handleToggle(id) {
    let handler = faqs
      .filter((faq) => faq.id === id)
      .map((faq) => (faq.show === open ? true : false));
    setOpen(handler[0]);
    setToggle(id);
  }

  return (
    <div className="bg-[#f9fafb] w-full min-h-screen pb-10  my-10 sm:px-20">
      <Starter header={"Frequently Asked Questions"} btnText={"See more"} />
      <div className="space-y-3 p-2">
        {faqs.map((faq) => (
          <Accordion
            key={faq.id}
            onClick={() => handleToggle(faq.id)}
            {...faq}
            compare={toggle !== faq.id}
            open={open}
          />
        ))}
      </div>
      <CustomerSurvey />
    </div>
  );
};

export default Faq;
